<template>
  <button :type="type ? type : 'submit'" :class="css ? 'm-btn m-btn--'+css : 'm-btn m-btn--default'" v-ripple>
    <slot>ボタン</slot>
  </button>
</template>

<script>
export default {
  props: ['type', 'css'],
  mounted () {
  }
}
</script>

<style lang="scss">
.m-btn {
  font-size:1rem;
  font-weight: bold;
  width: 100%;
  text-align: center;
  padding: 1em;
  border: 0;
  cursor: pointer;
  transition: opacity 0.5s ease-in-out;

  &+& {
    margin-top: 1rem;
  }

  &:hover {
    opacity: .8;
  }

  &:focus {
    outline: 0;
  }

  /* &:active { */
  /*   background: red; */
  /* } */

  &--default {
    background-color: var(--color-point);
    color: #fff;
  }

  &--ghost {
    background-color: transparent;
    border: 1px solid #ccc;
    color: #000;
  }

  &--column {
    background-color: transparent;
    border: 1px solid #ccc;
    color: #000;
    margin-top: 0 !important;
    width: 120px;
    height: 27px;
    padding: 5px 0;
    font-weight: normal;
    font-size: 10px;
    margin-right: 1px;
    margin-bottom: 1px;
  }
}
</style>



// WEBPACK FOOTER //
// Button.vue?52176331